import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Typography } from '@mui/material';

import { CareTaskIntervention } from 'src/store/sageAdminApi';

export interface CareTaskInterventionListProps {
    interventions: CareTaskIntervention[];
}

const CareTaskInterventionList = ({ interventions }: CareTaskInterventionListProps) => (
    <Stack component="ul" sx={{ m: 0, pl: 2.5, gap: 1.5 }}>
        {interventions.map(({ displayName, note }, index) => (
            <Box component="li" key={`${displayName}-${index}`}>
                <Typography variant="body2">{displayName}</Typography>
                {note && (
                    <Stack direction="row" sx={{ gap: 1, pl: 1, pt: 1, alignItems: 'flex-start' }}>
                        <Typography variant="body2">
                            <FontAwesomeIcon icon={faArrowRight} />
                        </Typography>
                        <Typography variant="body2">{note}</Typography>
                    </Stack>
                )}
            </Box>
        ))}
    </Stack>
);

export default CareTaskInterventionList;
